module.exports = __webpack_public_path__ + "img/sync.49b8f245.svg";